export { default as VerifyWithIdMeArtwork } from './verify-with-idme.svg';

export { default as VerifiedByIdMeArtwork } from './verified-by-idme.svg';
